import { MfaChallengeMount } from "@components/MFAChallenge/MfaChallengeMount";
import { WSProvider } from "@wingspanhq/fe-component-library";
import React from "react";
import { Router } from "react-router-dom";
import { WSQueryProvider } from "../../query/WSQueryProvider";
import { wsStore } from "../../store";
import { history } from "../../store/history";
import { HistoryListener } from "../../utils/HistoryListener";
import { WSStoreProvider } from "../../utils/WSStore";
import { CaptchaProvider } from "../Captcha";

export const Providers: React.FC = props => {
  return (
    <Router history={history}>
      <WSStoreProvider store={wsStore}>
        <HistoryListener>
          <WSQueryProvider>
            <CaptchaProvider>
              <WSProvider>
                <MfaChallengeMount />
                {props.children}
              </WSProvider>
            </CaptchaProvider>
          </WSQueryProvider>
        </HistoryListener>
      </WSStoreProvider>
    </Router>
  );
};
